import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {AppSettings} from '../../proyect.conf';
import {map} from 'rxjs/operators';
import {ProductosSubdestinosActividad} from '../_models/productos-subdestinos-actividad';

@Injectable({
  providedIn: 'root'
})
export class ProductosSubdestinosActividadService {

  private rutaServicio = AppSettings.rutServiciosAPL + '/api/productosSubDestinosActividad';

  constructor(private httClient: HttpClient,
              private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get(this.rutaServicio).pipe(map(res => res as ProductosSubdestinosActividad[]));
  }

  listadoHabilitados() {
    return this.httClient.get(this.rutaServicio + '/enabled').pipe(map(res => res as ProductosSubdestinosActividad[]));
  }
  /**
   * Obtiene todos los registros por IdProductoSubDestinoActividad
   */
  obtenerPorId(id: string) {
    return this.httClient.get(this.rutaServicio + '/' + id).pipe(map(res => res as ProductosSubdestinosActividad));
  }

  /**
   * Obtiene todos los registros por idSubDestinoProducto
   */
  obtenerPoridSubDestinoProducto(idSubDestinoProducto: string) {
    return this.httClient.get(this.rutaServicio + '/subDestinoProducto/' + idSubDestinoProducto + '/enabled').pipe(map(res => res as ProductosSubdestinosActividad[]));
  }

  listaDestinoProducto(idDestinoProducto: string) {
    return this.httClient.get(this.rutaServicio + '/destinoProducto/' + idDestinoProducto).pipe(map(res => res as ProductosSubdestinosActividad[]));
  }
  listaDestinoProductoHabilitados(idDestinoProducto: string) {
    return this.httClient.get(this.rutaServicio + '/destinoProducto/' + idDestinoProducto + '/enabled').pipe(map(res => res as ProductosSubdestinosActividad[]));
  }

  listaProducto(idProducto: string) {
    return this.httClient.get(this.rutaServicio + '/producto/' + idProducto).pipe(map(res => res as ProductosSubdestinosActividad[]));
  }

  listaProductoHabilitados(idProducto: string) {
    return this.httClient.get(this.rutaServicio + '/producto/' + idProducto + '/enabled').pipe(map(res => res as ProductosSubdestinosActividad[]));
  }

  crearSubDestinosActividad( productosSubdestinosActividad: ProductosSubdestinosActividad ) {
    productosSubdestinosActividad.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutaServicio, productosSubdestinosActividad  ).pipe( map( res => res as  ProductosSubdestinosActividad) );
  }

  actualizarSubDestinosActividad( productosSubdestinosActividad: ProductosSubdestinosActividad ) {
    productosSubdestinosActividad.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutaServicio, productosSubdestinosActividad ).pipe( map( res => res as ProductosSubdestinosActividad ) );
  }

  bulk( productosSubdestinosActividad: ProductosSubdestinosActividad[] ) {
    productosSubdestinosActividad.map( ( s: ProductosSubdestinosActividad ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutaServicio + '/bulk', productosSubdestinosActividad ).pipe( map( res => res as ProductosSubdestinosActividad[] ) );
  }

}
